import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Router } from '@angular/router';

@Component({
    selector: 'app-popup',
    imports: [CommonModule],
    templateUrl: './popup.component.html',
    styleUrl: './popup.component.less'
})
export class PopupComponent {
  @Input() show = false;
  @Output() close = new EventEmitter<void>();
  @Input() popupData: any = {
    title: '',
    pnaNo: null as number | null,
    pnaYear: null as number | null,
    message: '',
    returnPath: '',
  };

  constructor(private router: Router) {}

  closePopup() {
    this.show = false;
    this.router.navigate([this.popupData.returnPath]);
    this.close.emit();
  }
}
